var _path, _rect, _path2, _rect2, _rect3, _rect4, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 256 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M0 23.5C0 19.3579 3.35786 16 7.5 16H74.5C78.6421 16 82 19.3579 82 23.5V23.5C82 27.6421 78.6421 31 74.5 31H7.5C3.35786 31 0 27.6421 0 23.5V23.5Z",
    fill: "#E6B012"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 35,
    y: 31,
    width: 75,
    height: 15,
    rx: 7.5,
    fill: "#E6B012"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M47 8.5C47 4.35786 50.3579 1 54.5 1H125V9C125 12.866 121.866 16 118 16H54.5C50.3579 16 47 12.6421 47 8.5V8.5Z",
    fill: "#E6B012"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 242,
    y: 87,
    width: 69,
    height: 15,
    rx: 7.5,
    transform: "rotate(180 242 87)",
    fill: "#E6B012"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 256,
    y: 72,
    width: 91,
    height: 15,
    rx: 7.5,
    transform: "rotate(180 256 72)",
    fill: "#E6B012"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 207,
    y: 102,
    width: 94,
    height: 15,
    rx: 7.5,
    transform: "rotate(180 207 102)",
    fill: "#E6B012"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M176.774 84.5396L176.77 84.5464C175.757 86.3183 174.288 87.7902 172.514 88.8104C170.739 89.8305 168.724 90.362 166.674 90.3498H166.67H89.3102C87.2617 90.3497 85.2495 89.8128 83.4762 88.7933C81.7028 87.7737 80.2309 86.3077 79.2083 84.5429C78.1857 82.7781 77.6483 80.7766 77.65 78.7399C77.6517 76.7032 78.1923 74.7027 79.2178 72.9395L117.898 6.44015C118.922 4.67985 120.393 3.21802 122.164 2.2016C123.936 1.18517 125.945 0.65 127.99 0.65C130.035 0.65 132.044 1.18517 133.816 2.2016C135.587 3.21802 137.059 4.67985 138.083 6.44016L176.762 72.9391L176.764 72.9424C177.801 74.7006 178.348 76.7017 178.35 78.7398C178.352 80.7779 177.808 82.7798 176.774 84.5396ZM89.31 81.1494H89.3102H166.67H166.67C167.093 81.1493 167.508 81.0385 167.874 80.828C168.24 80.6175 168.544 80.3144 168.756 79.9492C168.967 79.5838 169.079 79.1692 169.078 78.7471C169.078 78.3249 168.966 77.9109 168.754 77.5462L130.074 11.0464C130.074 11.0464 130.074 11.0464 130.074 11.0463C129.862 10.682 129.558 10.3798 129.192 10.1699C128.826 9.96007 128.412 9.84971 127.99 9.84971C127.568 9.84971 127.154 9.96007 126.788 10.1699C126.422 10.3798 126.118 10.682 125.906 11.0463C125.906 11.0464 125.906 11.0464 125.906 11.0464L87.2266 77.5457C87.0144 77.9106 86.9023 78.325 86.9019 78.7471C86.9015 79.1692 87.0128 79.5838 87.2245 79.9492C87.4361 80.3144 87.7404 80.6175 88.1065 80.828C88.4726 81.0385 88.8877 81.1493 89.31 81.1494ZM123.364 54.2519V33.2512C123.364 32.0321 123.851 30.8624 124.718 29.9994C125.585 29.1364 126.762 28.651 127.99 28.651C129.218 28.651 130.395 29.1364 131.262 29.9994C132.129 30.8624 132.616 32.0321 132.616 33.2512V54.2519C132.616 55.4709 132.129 56.6407 131.262 57.5036C130.395 58.3667 129.218 58.8521 127.99 58.8521C126.762 58.8521 125.585 58.3667 124.718 57.5036C123.851 56.6407 123.364 55.4709 123.364 54.2519ZM122.091 67.5734C122.574 66.4134 123.392 65.4214 124.442 64.7233C125.492 64.0251 126.727 63.6522 127.99 63.6522C129.684 63.6522 131.309 64.3221 132.506 65.5133C133.703 66.7045 134.375 68.3193 134.375 70.0025C134.375 71.2578 134.001 72.4851 133.3 73.5293C132.598 74.5736 131.601 75.3879 130.434 75.8689C129.267 76.35 127.983 76.4759 126.744 76.2306C125.505 75.9854 124.367 75.38 123.474 74.4917C122.582 73.6034 121.974 72.472 121.728 71.2408C121.482 70.0096 121.608 68.7334 122.091 67.5734Z",
    fill: "#E6B012",
    stroke: "white",
    strokeWidth: 1.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.1c3505698b35c5430944bd2dde1bebf1.svg";
export { ForwardRef as ReactComponent };